// Interface

import util from '@/utils/classToObject'
import { IRoomserviceState } from './state'

export class RoomServiceGetter {

    public datasStatus(state: IRoomserviceState) {
        return state.datasStatus
    }

    public arbosDic(state: IRoomserviceState) {
        return state.arbosDic
    }

    public allergenesDic(state: IRoomserviceState) {
        return state.allergenesDic
    }

    public biosDic(state: IRoomserviceState) {
        return state.biosDic
    }

    public accompagnementsDic(state: IRoomserviceState) {
        return state.accompagnementsDic
    }

    public platsDic(state: IRoomserviceState) {
        return state.platsDic
    }

    public iconsDic(state: IRoomserviceState) {
        return state.iconsDic
    }

    public arbosList(state: IRoomserviceState) {
        return state.arbosList.map(id => state.arbosDic[id])
    }

    public sectionsList(state: IRoomserviceState) {
        return state.sectionsList.map(id => state.sectionsDic[id])
    }

    public configuration(state: IRoomserviceState) {
        return state.configuration
    }

    public panier(state: IRoomserviceState) {
        return state.panier
    }

    public crenaux(state: IRoomserviceState) {
        return state.crenaux
    }
}

export default util.classToObject(RoomServiceGetter)